<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col">
        <card-item
          class="striped-tabled-with-hover"
          body-classes="table-full-width table-responsive"
        >
          <template slot="header">
            <div class="d-flex justify-content-between">
              <div>
                <h4 class="card-title">{{ titulo }}</h4>
                <p class="card-category">Suspensiones</p>
              </div>
            </div>
          </template>

          <div class="container-fluid">
            <div class="row">
              <div class="col">
                <ResumenDeudores></ResumenDeudores>
              </div>
            </div>
          </div>
        </card-item>
      </div>
    </div>
  </div>
</template>

<script>
import ResumenDeudores from "@/pages/Suspensiones/EvitarSuspensiones/ResumenDeudores";

export default {
  name: "EvitarSuspensiones",
  computed: {
    modo() {
      return this.$store.state.Suspensiones.suspensionesMODO;
    },
    titulo() {
      if (this.modo === "tratamiento") {
        return "Tratamiento de suspensiones";
      } else {
        return "Evitar suspensiones";
      }
    },
  },
  components: {
    ResumenDeudores,
  },
};
</script>

<style scoped></style>
